<ng-template #popTemplate><div [innerHtml]="helpText"></div></ng-template>

<!-- The helper icon. -->
<span class="fas fa-info-circle" title="Click for more information" [popover]="popTemplate" [outsideClick]="true" triggers="click" containerClass="qs-popover"></span>
